export default function uibDatepickerPopupWrap() {
  return function link($scope, $element) {
    if ($scope.datepickerOptions?.datepickerClass) {
      $element.addClass($scope.datepickerOptions.datepickerClass);
    }
  };
}
